import { IColumnDefinitionView } from '../../models/IColumnDefinitionView';

export class AddColumnDefinition {
  static readonly type = '[COLDEF] add';
  constructor(public payload: IColumnDefinitionView[]) {}
}

export class RemoveColumnDefinition {
  static readonly type = '[COLDEF] remove';
  constructor() {
    /**/
  }
}
